import React from 'react';
import { useTranslation } from 'react-i18next';
import { Transition } from '@headlessui/react';

import ReactDOM from 'react-dom';
import { useMobxStores } from '@stores/store';
import { observer } from 'mobx-react';
import NoSSR from '@molecules/NoSSR';
import SimpleYoutube from '@molecules/slider/SimpleYoutube';
import Layer from '@molecules/modal/Layer';
import { useLocation, useNavigate } from 'react-router-dom';
import ShareBtn from '@atoms/btn/ShareBtn';
import GdprAccordion from '@molecules/accordion/GdprAccordion';
import { t } from 'i18next';

const Portal = ({ children }) => {
  return ReactDOM.createPortal(children, document.querySelector('body'));
};

const GdprDetailDialog = () => {
  const { t, i18n } = useTranslation();
  const { settingStore } = useMobxStores();

  const navigate = useNavigate();
  const location = useLocation();
  const onClose = () => {
    settingStore.setGdprDetailDialogState(false);
    settingStore.setGdprDialogState(false);
  };

  return (
    <NoSSR>
      <div className="relative z-20 text-left  w-full">
        <Transition
          show={settingStore.gdprDetailDialogState}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        ></Transition>
        <Portal>
          <Layer
            isOpen={settingStore.gdprDetailDialogState}
            onClose={() => onClose()}
          >
            <div className="shadow-xl items-center text-center w-full bg-white rounded">
              <h1 className="py-5 text-xl font-TmoneyRoundWind font-bold mt-5">
                {t('쿠키 수집 동의')}
              </h1>
              <p className="px-10">
                {t(
                  '더 나은 인더섬 with BTS 경험을 위해 쿠키 수집에 동의해주세요.'
                )}
              </p>
              <div>
                <GdprAccordion />
              </div>
            </div>
          </Layer>
        </Portal>
      </div>
    </NoSSR>
  );
};

export default observer(GdprDetailDialog);
